module.exports = __webpack_public_path__ + "img/productRobot_24.74e118eb.png";